import { useContext } from "react";
import RegistrationContext from "../../contexts/RegistrationContext";
import Logout from "../../pages/Logout";
import LeaveImpersonation from "../../components/LeaveImpersonation";
import "./style.css";
import { User, UserCog } from "lucide-react";
function AuthStatus() {
  const {
    authenticated,
    screen,
    setScreen,
    maxStep,
    setUserInfoOpen,
    isAdmin,
    isImpersonating,
    reload,
    setReload,
  } = useContext(RegistrationContext);

  const isAdminScreen = screen.startsWith("admin");

  const adminIconClick = () => {
    if (isAdminScreen) {
      setScreen(maxStep);
      setReload(reload + 1);
    } else {
      setScreen("admin-dashboard");
    }
  };
  if (authenticated) {
    return (
      <div className="flex">
        {!isAdminScreen && (
          <>
            <div className="ml-6">
              <User
                onClick={() => {
                  setUserInfoOpen(true);
                }}
                style={{ cursor: "pointer" }}
              />
            </div>
          </>
        )}
        {isAdmin && (
          <div className="ml-6 text-pink-500 cursor-pointer">
            <UserCog onClick={() => adminIconClick()} />
          </div>
        )}
        {isImpersonating ? (
          <div className="ml-6">
            <LeaveImpersonation />
          </div>
        ) : (
          <div className="ml-6">
            <Logout />
          </div>
        )}
      </div>
    );
  } else {
    return (
      <div>
        <button className="button" onClick={() => setScreen("signin")}>
          Sign up
        </button>
      </div>
    );
  }
}

export default AuthStatus;
